<template>
  <div id="struct_rule">
    <div id="container">
      <div id="content">
        <div class="title">
          <h2>組立・設置サービスにおける注意事項・免責事項</h2>
        </div>
        <section class="terms_sec">
          <ul>
            <li>・商品到着後速やかに商品に破損、不良又は不足等がないかを確認してください。</li>
            <li>・組立・設置の作業スペースの確保が難しい場合には予め当社に連絡してください。</li>
            <li>・床・壁・天井の材質により固定できない場合(漆喰やベニヤ等)や十分な耐荷重を</li>
            <li class="indent">得られない場合は、契約キャンセルとなります。</li>
            <li class="indent">その場合でも家具はお買取りいただき、組立技術料はご請求させていただきます。</li>
            <li>・実際の組立技術料が現場状況などにより、当初の見積料金より高くなる場合が</li>
            <li class="indent">ございます。</li>
            <li class="indent">その場合は、作業前に協議を行い、双方合意の上で代金額を決定した上で</li>
            <li class="indent">組立設置作業を行います。</li>
            <li>・ご注文後のキャンセルは、お受けいたしかねますので、予めご了承ください。</li>
            <li class="indent">(返金いたしかねますので、ご了承ください)</li>
            <li>・床・壁・天井への固定が必要な設置の場合には、床・壁・天井に穴を空けること</li>
            <li class="indent">について予めご承諾いただいたものとします。</li>
            <li>・当社の組立・設置が終了した後、お客様は完了確認をお願いします。</li>
            <li>・当社は、お客様起因による家具組立前の破損等について一切の責任を負いません。</li>
            <li>・組立・設置後の代金の返金請求は一切お受けできません。</li>
            <li>・不要な家具の引き取りは行っておりません。</li>
          </ul>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'StructRuleDetial',
  components: {
  },
  props: {
  },
  data () {
    return {
      isTitle: false
    }
  },
  methods: {
    scrollEvent: function () {
      let element = document.getElementById('struct_rule')
      if (element.scrollHeight - (element.offsetHeight + element.scrollTop) < element.scrollHeight * 0.05) {
        this.$emit('onScrollEnd')
        document.getElementById('struct_rule').removeEventListener('scroll', this.scrollEvent)
      }
    }
  },
  computed: {
  },
  mounted: function () {
    document.getElementById('struct_rule').addEventListener('scroll', this.scrollEvent)
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/input-list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/common/DcStructRuleDetial.vue